"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckBoxLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _consts = require("../../../consts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CheckBoxLabel = exports.CheckBoxLabel = function CheckBoxLabel(_ref) {
  var _ref$term = _ref.term,
    term = _ref$term === void 0 ? "monthly" : _ref$term;
  return /*#__PURE__*/_react["default"].createElement("span", null, "I certify that I have read the", " ", /*#__PURE__*/_react["default"].createElement("a", {
    href: _consts.BOOST_TERMS_AND_CONDITIONS_URL,
    target: "_blank",
    rel: "noreferrer",
    className: "italic hover:text-boost-primary-purple"
  }, "terms and conditions"), " ", "of TomoBoost and understand that this is a ", term, " subscription. I understand the refund and cancellation policy and agree to this subscription.");
};